import script from "./BusinessPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessPlan.vue?vue&type=script&setup=true&lang=js"

import "./BusinessPlan.vue?vue&type=style&index=0&id=265b0036&lang=css"

const __exports__ = script;

export default __exports__